
import { Component, Prop, Vue } from 'vue-property-decorator';
import TransactionsView from '@/modules/transaction/views/Transactions/TransactionsView.vue';
import TransactionsLegacyView from '@/modules/transaction/views/TransactionsLegacy/TransactionsLegacyView.vue';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

@Component({
  components: {
    TransactionsView,
    TransactionsLegacyView
  }
})
export default class TransactionsPage extends Vue {
  @Prop({ type: String, required: false })
  readonly transactionsStep?: string;

  get isUnifiedAccountEnabled() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.UNIFIED_ACCOUNT);
  }
}
